import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const db = firebase.firestore();
const storage = firebase.storage().ref();

// TODO: need invite DB schema to fire off invite and to track who invited who
// can track by current uid and invitee email
// then update with UID on invite acceptance

export function ChangePhoto() {
  const { user } = useAuthState(firebase.auth());
  const [value, setValue] = useState();
  const [submit, setSubmit] = useState(false);
  const [errors, setErrors] = useState('');

  const handleSubmit = async e => {
    // const { email } = value;
    const { uid } = user;
    e.preventDefault();

    try {
      const uploadedFile = await storage
        .child(`avatars/${uid}`)
        .put(value.file);

      const downloadUrl = await uploadedFile.ref.getDownloadURL();

      await db
        .collection('userPhotos')
        .doc(uid)
        .set({
          uid,
          downloadUrl
        });

      setSubmit(true);
    } catch ({ message }) {
      setErrors(message);
    }
  };

  const handleChange = e => {
    setValue({ ...value, [e.target.name]: e.target.files[0] });
  };

  return (
    <>
      <Header>Upload your photo</Header>
      {errors && <p>{JSON.stringify(errors)}</p>}
      {submit ? (
        <Card>
          <p>Your profile picture has been uploaded and replaced!</p>
        </Card>
      ) : (
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <label>Pick your photo</label>
            <input type="file" name="file" onChange={e => handleChange(e)} />
          </FormGroup>
          <Button type="submit">Change photo</Button>
        </Form>
      )}
    </>
  );
}

const Header = styled.h2`
  font-family: sans-serif;
  margin-bottom: 5px;
`;

const Insructions = styled.p`
  font-family: sans-serif;
  margin-bottom: 30px;
`;

const Card = styled.div`
  font-family: sans-serif;
  background-color: var(--theme-primary-color);
  max-width: 100%;
  padding: 20px;
  border-radius: 24px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 46%);
`;

const Form = styled.form`
  font-family: sans-serif;
  background-color: var(--theme-primary-color);
  max-width: 100%;
  padding: 20px;
  border-radius: 24px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 46%);
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
  label,
  input {
    display: block;
  }

  label {
    font-weight: bold;
  }

  input {
    box-sizing: border-box;
    margin-top: 5px;
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    border-radius: 8px;
    border: 1px solid var(--theme-secondary-color);
  }
`;

const Button = styled.button`
  display: block;
  width: 100%;
  padding: 20px;
  background-color: var(--theme-secondary-color);
  color: white;
  font-size: 1.2rem;
  border-radius: 8px;
  border: 0;
`;
